var map = {
	"./ai_music.png": "0fdb",
	"./ai_picture.jpg": "d1f4",
	"./ai_video.jpg": "0278",
	"./ai_yuyin.jpg": "1391",
	"./icon-star-red.png": "af54",
	"./icon-star-white.png": "1448"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02a8";